'use client'

import Link from 'next/link'
import type { ComponentProps } from 'react'

import { FieldPassword } from '@/shared/components/form/form-fields'
import { LoadingButton } from '@/shared/components/feedback/loading-button'
import { Form } from '@/shared/components/ui/form'
import { cn } from '@/shared/utils/cn'
import { useResetPasswordForm } from '../hooks/use-reset-password-form'


export function ResetPasswordForm({ className, ...props }: ComponentProps<'div'>) {
  const { form, isSuccess, isLoading, errorMessage, onSubmit, token } = useResetPasswordForm()

  if (!token) {
    return (
      <div className={cn('flex flex-col gap-6', className)} {...props}>
        <p role="alert" className="text-sm text-destructive">
          Geçersiz veya eksik sıfırlama bağlantısı. Lütfen e-postanızdaki bağlantıyı kontrol edin.
        </p>
        <Link href="/forgot-password" className="text-sm text-primary hover:underline">
          Yeni sıfırlama bağlantısı al
        </Link>
      </div>
    )
  }

  return (
    <div className={cn('flex flex-col gap-6', className)} {...props}>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
          <FieldPassword
            name="new_password"
            label="Yeni Şifre"
            autoComplete="new-password"
            showVisibilityToggle
          />

          <FieldPassword
            name="new_password_confirm"
            label="Yeni Şifre (Tekrar)"
            autoComplete="new-password"
            showVisibilityToggle
          />

          {isSuccess && (
            <p role="status" className="rounded-md border border-primary/20 bg-primary/5 px-4 py-3 text-sm text-primary">
              Şifreniz başarıyla güncellendi. Giriş sayfasına yönlendiriliyorsunuz...
            </p>
          )}

          {errorMessage && (
            <p role="alert" className="text-sm text-destructive">{errorMessage}</p>
          )}

          <LoadingButton type="submit" className="w-full" loading={isLoading} disabled={isSuccess}>
            Şifreyi Güncelle
          </LoadingButton>
        </form>
      </Form>

      <p className="text-center text-sm text-muted-foreground">
        Parolanızı hatırladınız mı?{' '}
        <Link href="/login" className="font-medium text-foreground underline-offset-4 hover:underline">
          Giriş yapın
        </Link>
      </p>
    </div>
  )
}
